import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Catches Supabase password-recovery redirects that land on the wrong path
 * (e.g. https://bigfollow.lovable.app/#access_token=...&type=recovery)
 * and forwards them to /passwort-zuruecksetzen while preserving the hash
 * so Supabase can still parse the recovery session.
 */
export default function RecoveryHashRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hash = window.location.hash;
    if (!hash || !hash.includes('type=recovery')) return;

    // Already on the reset page – nothing to do
    if (location.pathname.includes('passwort-zuruecksetzen')) return;

    navigate('/passwort-zuruecksetzen' + hash, { replace: true });
  }, [location.pathname, navigate]);

  return null;
}